export default "__VITE_ASSET__CgYuomg4__"